import React from 'react';
import { Link } from "react-router-dom";
import $ from 'jquery';
import DriverModal from '../modal/DriverModal'
import { db } from '../firebase';
import { MyContext } from '../context';
import { Content, BadgeMenu } from '../components';
export default class Trips extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: 0,
      target: null,
      page: { start: 0, end: 10, interval: 10 }
    }
    this.detailModal = React.createRef();
    this.deleteModal = React.createRef();
  }
  componentDidMount() {
    let _this = this;
    $(document).click(function (event) {
      if (_this.state.target !== event.target) {
        $(".dropdown-menu").hide();
      }
    });
  }
  showPopup(e) {
    let target = e.target
    var c = $(target).parent().find(".dropdown-menu");
    $(".dropdown-menu").hide();
    $(c[0]).show();
    this.setState({ target: target });
  }
  showModal(modal, driver, key) {
    modal.current.showModal();
    modal.current.setState({
      show: true,
      driver,
      key
    });
    this.setState({
      key
    })
  }
  updateDriver(status, key) {
    db.updateDriver(key, status);
  }
  editDriver(obj, key) {
  }
  deleteDriver(driver, key) {
    this.deleteModal.current.showModal('trips');
    this.deleteModal.current.setState({
      show: true,
      driver,
      key
    })
  }
  filter(filter) {
    let { page } = this.state;
    page.start = 0;
    page.end = 10;
    this.setState({
      filter, page
    })
  }
  subMenu() {
    return (
      <li className="m-nav__item">
        <Link to={window.location.pathname} className="m-nav__link">
          <span className="m-nav__link-text">Trips</span>
        </Link>
      </li>
    )
  }
  leftMenu() {
    return (
      <MyContext.Consumer>
        {state => {
          return (
            <React.Fragment>
              <BadgeMenu className="m-badge m-badge--info" onClick={(e) => { this.filter(0) }} title="All Trips" value={state.trips.length} />
              <BadgeMenu className="m-badge m-badge--success" onClick={(e) => { this.filter(1) }} title="Complete Trips" value={state.completeTrip} />
              <BadgeMenu className="m-badge m-badge--success" onClick={(e) => { this.filter(2) }} title="Complete Trips" value={state.onGoing} />
              <BadgeMenu className="m-badge m-badge--success" onClick={(e) => { this.filter(3) }} title="Cancelled Trips" value={state.cancelledTrip} />
              <BadgeMenu className="m-badge m-badge--success" onClick={(e) => { this.filter(4) }} title="Pending Trips" value={state.requstTrip} />
            </React.Fragment>
          )
        }}
      </MyContext.Consumer>
    )
  }
  render() {
    return <Content state={this} title="Trips" />
  }
  content() {
    let sn = this.state.page.start + 1;
    return (
      <MyContext.Consumer>
        {state => {
          return (
            <React.Fragment>
              <table id="example" className="table table-striped table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>S.N.</th>
                    <th>User Name</th>
                    <th>Location (From)</th>
                    <th>Driver Name</th>
                    <th>Location (To)</th>
                    {this.state.filter == 3 &&
                      <th>Reason</th>
                    }
                    <th>Date/Time</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    state.trips
                      .filter(item => {
                        return this.state.filter == 0
                          || (this.state.filter == 1 && item.isTripOver)
                          || (this.state.filter == 2 && item.status && item.isTripStarted)
                          || (this.state.filter == 3 && !item.status)
                          || (this.state.filter == 4 && item.status && !item.isTripStarted)
                      }).slice(this.state.page.start, this.state.page.end)
                      .map((item) => {
                        return this.comp(item, sn++);
                      })
                  }
                </tbody>
              </table>
              <DriverModal ref={this.detailModal} id="driverDetailModel" footer={
                <div className="modal-footer">
                  {/* <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button> */}
                  <button type="button" className="btn btn-primary">Edit Driver</button>
                </div>
              } />
              <DriverModal ref={this.deleteModal} id="driverDeleteModel" footer={
                <div className="modal-footer">
                  <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.delete.bind(this)}>Delete Driver</button>
                  <button type="button" className="btn btn-primary" onClick={this.close.bind(this)}>Cancel</button>
                </div>
              } />
            </React.Fragment>
          )
        }}
      </MyContext.Consumer>
    )
  }
  delete(e) {
    db.deleteDriver(this.state.key);
    this.deleteModal.current.setState({
      show: false
    })
  }
  close(e) {
    this.deleteModal.current.setState({
      show: false
    })
  }
  comp(item, sn) {
    let fullName = item.fullName || "";
    if (this.props.search == "" || fullName.toLowerCase().includes(this.props.search.toLowerCase().trim())) {
      var strDate = "";
      if (item.time) {
        let date = new Date(item.time);
        let month = date.getMonth() + 1
        strDate = (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()) + "/" + (month < 10 ? "0" + month : month) + "/" + date.getFullYear();
      }
      return (
        <tr key={item.key}>
          <td>{sn}</td>
          <td>{item.fullName}</td>
          <td>{item.pickupAddress}</td>
          <td>{item.driverName}</td>
          <td>{item.dropoffAddress}</td>
          {this.state.filter == 3 &&
            <td>{item.reason}</td>
          }
          <td>{strDate}</td>
        </tr>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/include/Trips.js